import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */
// Following appointo_client pattern - actions with params and callback
const { Types, Creators } = createActions({
  signInRequest: ['params', 'callback'],
  signUpRequest: ['params', 'callback'],
  signOutRequest: ['callback'],
  meRequest: ['callback'],
  switchTeam: ['teamId', 'callback'],
  startupRequest: ['callback'],
  startupComplete: null,
  setAuthData: ['data'],
  getCurrentUserSuccess: ['user', 'teams'],
  clearAuthData: null,
})

export const AuthTypes = Types
export default Creators

/* ------------- Initial State ------------- */
// Following appointo_client pattern - minimal state, auth stored in localStorage
const INITIAL_STATE = {}

/* ------------- Reducer ------------- */
export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    default:
      return state
  }
}
